import type { ModelData } from '@/shared/stores/model-utils'

export const model3InitialModel: ModelData = {
  modelId: '',
  name: '',
  photoId: null,
  type: 'DOOR',
  width: 0,
  height: 0,
  serviceIds: [],
  serviceNames: [],
  description: '',
  parameters: [],
  doorConfiguration: {
    type: 'single_door',
    totalDoorWidth: 0,
    individualDoorWidth: [],
    totalHandles: 0,
    openingDirection: 'inward_and_outward_swing',
    hingePosition: 'right',
  },
}
